import { render, staticRenderFns } from "./MessageUnknown.vue?vue&type=template&id=29ee3145&"
import script from "./MessageUnknown.vue?vue&type=script&lang=js&"
export * from "./MessageUnknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports